import { Toaster } from "components/notification/Toaster";
import { isArrayNotEmpty, isFunction, isUserAccessDenied } from "functions";
import ic_delete_invoices from 'assets/images/ic_delete_invoices.svg';


export function deliveredInvoices(props) {
    const {
        selectedInvoices
    } = props;

    let filters = {
        postStatus: "posted",
        lastSendMail: "sent",
        advancePayStatus: "normal",
    }
    let tabDetails = {
        id: "delivered",
        text: "Delivered",
        filters
    };

    let tableActions = [
        {
            icon: ic_delete_invoices,
            label: "Delete",
            isDisabled: isUserAccessDenied(props, "Internal_ProformaInvoice_Delete"),
            onClick: () => { 
                if (isArrayNotEmpty(selectedInvoices)) {
                    if (isFunction(props.setIsModalVisible_deleteInvoice))
                        props.setIsModalVisible_deleteInvoice(true);
                }
                else {
                    Toaster({
                        type: "info",
                        msg: "Please select at least 1 invoice.",
                    });
                }
            },
        },
        // {
        //     icon: ic_export,
        //     label: "Export",
        //     onClick: exportInvoices,
        // },
    ];

    return {
        tabDetails,
        filters,
        tableActions
    };
}